import timeago from 'timeago.js';

// Timeago.js
timeago().render(document.querySelectorAll('.timeago'));



// WEBPACK FOOTER //
// ./src/js/modules/timeago.js